angular.module('app')
    .directive('animatedGenericSolutions', animatedGenericSolutions)
function animatedGenericSolutions() {
    return {
        restrict: 'E',
        require: {
            scrollableContents: '^^scrollableContents',
            scrollableItem: '^^scrollableItem'
        },
        link: link
    }

    function link(scope, element, attrs, ctrl) {
        const container = angular.element(element);
        const footer = angular.element('scrollable-contents #footer');
        const isMobile = ctrl.scrollableContents.isMobile;

        let tweenGeneric = null;

        function animate() {
            const xLargeTextDesktop = container.find('.xlarge-text-desktop');
            const xLargeTextMobile = container.find('.xlarge-text-mobile');
            const introText = container.find('.intro-text');
            const secondText = container.find('.second-text');
            const logoContainer = container.find('.logo-container');
            const logoBox = container.find('.logo-box');
            const circularLogoSlogan = container.find('.logo-slogan');
            const secondLogoContainer = container.find('.second-logo-container');
            
            if (!isMobile) {
                tweenGeneric = new TimelineMax()
                    //.set(logoContainer, { bottom: '10%', opacity: 0, y: 0, scale: 1 })
                    .set(secondLogoContainer, { y: -221, opacity: 0, scale: 1 })
                    //.set(introText, { scale: 1.5 })
                    //.to(xLargeTextDesktop, 1, { scale: 1, opacity: 1, ease: Elastic.easeInOut })
                    //.to(introText, 1, { scale: 1, startAt: { scale: 1.5 }, opacity: 1, ease: Power4.easeInOut }, '-=1')
                    //.to(introText, 0.5, { y: 0, startAt: { y: -300 }, opacity: 1, ease: Power4.easeInOut }, '-=1')
                    .to(logoBox, 1.25, { y: 0, startAt: { y: 500 }, opacity: 1, ease: Power2.easeInOut })
                    .to(logoContainer, 1.25, { y: 0, startAt: { y: 500 }, opacity: 1, ease: Power2.easeInOut }, '-=1.25')
                    .to(container.find('.top-left-border'), 0.5, { x: -223, ease: Power3.easeInOut }, '-=0.75')
                    .to(container.find('.top-right-border'), 0.5, { x: 224, ease: Power3.easeInOut }, '-=0.75')
                    //.set(logoContainer, { opacity: 1 }, '-=1')
                    .to(logoContainer, 1, { y: -200, ease: Elastic.easeInOut }, '-=0.25')
                    .to(logoBox, 1, { y: 500, opacity: 0, display: 'none', ease: Power2.easeInOut }, '-=0.75')

                    .to(circularLogoSlogan, 1.25, { scale: 3, opacity: 0, ease: Power4.easeInOut }, '-=0.5')
                    //.to(xLargeTextDesktop, 0.75, { scale: 0, opacity: 0, ease: Elastic.easeInOut }, '-=0.4')
                    //.to(introText, 0.5, { scale: 1.5, opacity: 0, ease: Power1.easeInOut }, '-=0.6')
                    .set(logoContainer, { opacity: 0 }, '-=0.5')
                    .set(secondLogoContainer, { opacity: 1 }, '-=0.5')
                    .to(secondLogoContainer, 1.5, { y: -300, scale: 1.2, ease: Power2.easeInOut }, '-=0.75')
                    .to(secondText, 0.75, { y: 0, startAt: { y: +300 }, opacity: 1, display: 'block', ease: Power4.easeInOut }, '-=0.75')
            }
            else {
                tweenGeneric = new TimelineMax()
                    //.to(introText, 0.5, { scale: 1, startAt: { scale: 1.5 }, opacity: 1, ease: Power4.easeInOut })
                    //.to(xLargeTextMobile, 1, { scale: 1, opacity: 1, ease: Elastic.easeInOut }, '-=1')
                    .to(logoBox, 1.25, { y: 0, startAt: { y: 500 }, opacity: 1, ease: Elastic.easeInOut })
                    .to(logoContainer, 1.25, { y: 15, startAt: { y: 500 }, opacity: 1, ease: Elastic.easeInOut }, '-=1.25')

                    .to(container.find('.top-left-border'), 0.25, { x: -138, ease: Power3.easeInOut }, '-=0.25')
                    .to(container.find('.top-right-border'), 0.25, { x: 138, ease: Power3.easeInOut }, '-=0.25')
                    .to(logoBox, 1, { y: 500, opacity: 0, display: 'none', ease: Power2.easeInOut })
                    .to(logoContainer, 0.75, { y: -150, ease: Power2.easeInOut }, '-=1')

                    .to(circularLogoSlogan, 1, { scale: 3, opacity: 0, ease: Power4.easeInOut }, '-=0.75')
                    .to(xLargeTextMobile, 1, { scale: 0, opacity: 0, ease: Elastic.easeInOut }, '-=1')
                    .to(introText, 0.5, { scale: 1.5, opacity: 0, ease: Power4.easeInOut }, '-=1.25')
                    .to(logoContainer, 1, { y: -210, scale: 1.1, ease: Power2.easeInOut }, '-=0.5')
                    .to(secondText, 1, { y: 50, startAt: { y: 200 }, opacity: 1, display: 'block', ease: Power4.easeInOut }, '-=0.75')
                    
            }

            tweenGeneric.eventCallback('onComplete', function () {
                if (parseInt(ctrl.scrollableItem.contentIndex) === parseInt(ctrl.scrollableContents.totalSections)) {
                    ctrl.scrollableContents.setArrowVisibility(false);
                    ctrl.scrollableContents.setFooterVisibility(true);
                }
                else {
                    ctrl.scrollableContents.setArrowVisibility(true);
                }
            })
        }

        scope.$on('animate', function (event, args) {
            ctrl.scrollableContents.setArrowVisibility(false);
            if (args.index === parseInt(ctrl.scrollableItem.contentIndex)) {
                if (tweenGeneric) {
                    tweenGeneric.time(0).restart();
                }
                else {
                    animate();
                }                
            }
        })

        scope.$on('pauseAnimation', function (event, args) {
            if (args.index === parseInt(ctrl.scrollableItem.contentIndex)) {
                if (tweenGeneric) {
                    tweenGeneric.pause();
                }
            }
        })
    }
}